import React from "react";
import { Form } from "../../components/Form";
import { createReplacer } from "./Replacer";

const injectHubspot = createReplacer({
  supports({ attribs, name }) {
    return name === "form" && attribs?.["data-replacer"] === "hubspot";
  },
  replace({ attribs }) {
    return (
      <Form formID={attribs["data-form-id"]} className="not-wysiwyg contact" />
    );
  },
});

export default injectHubspot;
